import {
  Box,
  Heading,
  axiomTokens,
  MaterialIcons,
} from '@iclinic/design-system';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import * as Styles from './styles';
import DropDown from 'features/tissInvoicing/components/ui/DropDown';
import { getTissVersionState } from 'features/tissInvoicing/state/appointmentGuideList/selectors';

const { KeyboardArrowDown } = MaterialIcons;

export default function HeaderGuideList() {
  const versions = useSelector(getTissVersionState);
  const [open, setOpen] = useState(false);

  const handleSetOpen = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      marginBottom={axiomTokens.spacing['4']}
    >
      <Heading variant="lg">Guias de consulta</Heading>

      <DropDown
        open={open}
        items={versions.map((version) => ({
          id: version,
          title: version,
          href: `/tiss/guias-consulta/adicionar/?p=1&v=${version}`,
        }))}
        onClose={setOpen}
      >
        <Styles.Container>
          <Styles.LinkButton
            href="/tiss/guias-consulta/adicionar"
            size="medium"
            color="primary"
            variant="contained"
          >
            Adicionar guia
          </Styles.LinkButton>
          <Styles.ButtonList onClick={handleSetOpen}>
            <KeyboardArrowDown />
          </Styles.ButtonList>
        </Styles.Container>
      </DropDown>
    </Box>
  );
}
